module.exports = __webpack_public_path__ + "img/3.8d23c9c2.jpg";